import VennComponent from './component/VennComponent.vue';

export default {
    template: `<div><slot v-bind="self" /></div>`,
    props: ['domains'],
    data() {
        return {
            dm: {},
            keysType: 0,
            incl: "",
            excl: "",
        }
    },
    mounted() {
        this.domains.forEach(d => this.dm[d.id] = 1);
    },
    computed: {
        self() {
            return this;
        },
    },
    methods: {
        refreshValues: function (data) {
            this.domains.forEach(d => this.dm[d.id] = -1);
            this.incl = ""
            this.excl = ""
            data.forEach(d => this.dm[d] = 1);
        },
        submitReport: function (type){
            this.keysType = type;
            let emptyError = true
            for (let id in this.dm) {
                if (this.dm[id] === 1) {
                    emptyError = false
                    break
                }
            }
            let incl = [],
                excl = []
            this.domains.forEach(domain => {
                if (this.dm[domain.id] === 1) {
                    incl.push(domain.name)
                }
                if (this.dm[domain.id] === -1) {
                    excl.push(domain.name)
                }
            });
            this.incl = incl.join(',')
            this.excl = excl.join(',')
            if (emptyError) {
                window.location.search += '&notblank=1';
                return;
            }
            setTimeout(()=>{
                document.getElementById("compareForm").submit();
            }, 0);
        }
    },
    components: {
        'venn-component': VennComponent,
    },
}
